/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'rss': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#f78422" d="M0 0h32v32H0V0z"/><path pid="1" _fill="#fff" d="M20.799 11.176C16.462 6.839 10.692 4.451 4.551 4.451v4.518c4.934 0 9.57 1.918 13.053 5.402s5.402 8.119 5.402 13.053h4.518c0-6.141-2.389-11.911-6.725-16.248z"/><path pid="2" _fill="#fff" d="M4.504 12.096v4.518c5.96 0 10.809 4.849 10.809 10.809h4.518c0-8.452-6.876-15.327-15.327-15.327z"/><path pid="3" _fill="#fff" d="M10.948 24.313a3.236 3.236 0 11-6.472 0 3.236 3.236 0 016.472 0z"/>'
  }
})
